import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Zap, Globe } from 'lucide-react';
import { Logo } from '../common/Logo';

export const Footer: React.FC = () => {
  return (
    <footer className="border-t border-[#292a73] bg-[#1a1b4b] text-slate-300">
      <div className="container mx-auto max-w-7xl px-4 py-14 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="space-y-3.5 md:col-span-1">
            <Logo size="md" showTagline={true} />
            <p className="text-sm text-slate-300 leading-relaxed pt-1">
              Enterprise-grade cross-platform real-time collaboration. Web, Desktop & Mobile.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-sm mb-4 text-white uppercase tracking-wider">Product</h4>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li><Link to="/features" className="hover:text-[#3a9efd] transition">Features</Link></li>
              <li><Link to="/pricing" className="hover:text-[#3a9efd] transition">Pricing</Link></li>
              <li><Link to="/download" className="hover:text-[#3a9efd] transition">Download Apps</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm mb-4 text-white uppercase tracking-wider">Platform</h4>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li><span className="flex items-center gap-2"><Zap className="h-4 w-4 text-[#3a9efd]" /> Realtime STOMP</span></li>
              <li><span className="flex items-center gap-2"><Shield className="h-4 w-4 text-[#f7a400]" /> PostgreSQL & Flyway</span></li>
              <li><span className="flex items-center gap-2"><Globe className="h-4 w-4 text-[#3a9efd]" /> Cross-Platform Sync</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm mb-4 text-white uppercase tracking-wider">Security</h4>
            <p className="text-xs text-slate-300 leading-relaxed mb-3">
              Role-based tenant isolation, token-family replay prevention, SHA-256 invite hashing, and channel-scoped idempotency.
            </p>
            <div className="text-xs font-mono text-cyan-300 bg-[#292a73] p-2.5 rounded-lg border border-[#3e4491] inline-block">
              v1.0.0-production
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#3e4491]/60 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} Sahaj Connect by Hutech Solutions. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#3a9efd] transition">Privacy Policy</a>
            <a href="#" className="hover:text-[#3a9efd] transition">Terms of Service</a>
            <a href="#" className="hover:text-[#3a9efd] transition">Security Overview</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
